import { Component, inject, Inject, Input } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
 selector: 'iho-distance-modal',
 standalone: true,
 imports: [NgIf, NgFor, CommonModule],
 templateUrl: './distance-modal.component.html',
 styleUrls: ['./distance-modal.component.scss'],
})
export class DistanceModalComponent {
 @Input() _data: any;

 constructor(
  @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DistanceModalComponent>
 ) {
    
 }
}
